/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

/** @jsx jsx */

import { jsx } from '@emotion/react'
import { type FunctionComponent } from 'react'

import { EuiHealth, useEuiTheme } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'

type Props = {
  active: boolean
}

const Status: FunctionComponent<Props> = ({ active }) => {
  const { euiTheme } = useEuiTheme()

  if (active) {
    return (
      <EuiHealth color={euiTheme.colors.success}>
        <FormattedMessage id='billing.notifications.table.status.active' defaultMessage='Active' />
      </EuiHealth>
    )
  }

  return (
    <EuiHealth color={euiTheme.colors.danger}>
      <FormattedMessage id='billing.notifications.table.status.active' defaultMessage='Inactive' />
    </EuiHealth>
  )
}

export default Status
